import { connect } from 'react-redux';
import React, { Component } from 'react';
import Tab from '../../common/tab';
import './Strategy.scss';
import { getQueryParams } from '../../helpers/Common';
import FiinTradeStrategy from './fiinTradeStrategy/FiinTradeStrategy';
import TaStrategy from './taStrategy/TaStrategy';
import Canslim from './canslim/Canslim';
import ScrollComponent from '../../common/ScrollComponent';
import currentState from './../../helpers/CurrentState';
import ConstCommon from './../../common/Const';
import { changeIdHover } from './canslim/reducer';
import { COMPONENT_RESIZE } from '../../common/GoldenLayoutWrapper';

class MainContent extends Component {
  constructor(props) {
    super(props);
    const mapTab = {
      FiinTradeStrategy: 1,
      CANSLIM: 2,
      TaStrategy: 3,
    };
    const tabFromQuery = mapTab[getQueryParams('tab')];

    this.state = {
      widthScroll: 1,
      currentTab:
        tabFromQuery ||
        props.tab ||
        currentState.get(ConstCommon.listComponent.Strategy, 'currentTab') ||
        1,
    };
    this.scrollRef = React.createRef();
  }

  changeTab = currentTab => {
    currentState.add(
      ConstCommon.listComponent.Strategy,
      'currentTab',
      currentTab,
    );
    const { changeIdHover } = this.props;
    changeIdHover({});

    this.setState({ currentTab });
  };

  changeWidthScroll = () => {
    if (this.scrollRef.current) {
      this.setState({ widthScroll: this.scrollRef.current.scrollWidth });
    }
  };

  componentDidMount() {
    this.changeWidthScroll();
    window.addEventListener(COMPONENT_RESIZE, this.changeWidthScroll);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.widthScroll !== this.scrollRef.current.scrollWidth) {
      this.changeWidthScroll();
    }
  }

  componentWillUnmount() {
    window.removeEventListener(COMPONENT_RESIZE, this.changeWidthScroll);
  }

  render() {
    const { subTab } = this.props;
    return (
      <ScrollComponent>
        <div className="top-nav min-height-100 d-flex flex-column">
          <div
            className="px-20 pt-8 sticky"
            style={{ width: this.state.widthScroll }}
          >
            <Tab
              currentTab={this.state.currentTab}
              listTab="strategy.tabs"
              changeTab={this.changeTab}
            />
          </div>

          <div
            className="tab-content d-flex flex-fill h-auto"
            ref={this.scrollRef}
          >
            {this.state.currentTab === 1 && (
              <FiinTradeStrategy subTab={subTab} />
            )}
            {this.state.currentTab === 2 && <Canslim />}
            {this.state.currentTab === 3 && <TaStrategy subTab={subTab} />}
          </div>
        </div>
      </ScrollComponent>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    changeIdHover: item => dispatch(changeIdHover(item)),
  };
};

export default connect(
  null,
  mapDispatchToProps,
)(MainContent);
